import {
  NS_SAVE_MATCHING_CONFIG_DATA,
  NS_SAVE_MATCHING_CONFIG_DATA_TO_REDUX,
  NS_GET_MATCHING_CONFIG_PARAMATERS_DATA,
  NS_GET_MATCHING_CONFIG_PARAMATERS_SUCCESS,
  NS_GET_MATCHING_CONFIG_PARAMATERS_FAIL,
  NS_GET_MATCHING_CONFIG_LIST,
  NS_GET_MATCHING_CONFIG_LIST_FAIL,
  NS_GET_MATCHING_CONFIG_LIST_SUCCESS,
  NS_POST_CREATE_MATCHING_CONFIG,
  NS_POST_CREATE_MATCHING_CONFIG_SUCCESS,
  NS_POST_CREATE_MATCHING_CONFIG_FAIL,
  NS_GET_MATCHING_CONFIG_BY_ID,
  NS_GET_MATCHING_CONFIG_BY_ID_FAIL,
  NS_GET_MATCHING_CONFIG_BY_ID_SUCCESS,
  NS_GET_MATCHING_CONFIG,
  NS_GET_MATCHING_CONFIG_FAIL,
  NS_GET_MATCHING_CONFIG_SUCCESS,
  NS_PUT_UPDATE_MATCHING_CONFIG,
  NS_PUT_UPDATE_MATCHING_CONFIG_SUCCESS,
  NS_PUT_UPDATE_MATCHING_CONFIG_FAIL,
  NS_GET_MATCHING_CONFIG_RISK_INDICATORS_DATA,
  NS_GET_MATCHING_CONFIG_RISK_INDICATORS_SUCCESS,
  NS_GET_MATCHING_CONFIG_RISK_INDICATORS_FAIL
} from '../../actions/ns/matchingConfig';

export const initialState = {
  matchingConfigList: { isLoading: false, error: null, data: null },
  createUpdate: {
    matchingConfigurationName: {
      name: '',
      description: '',
      sourceIds: '',
      notes: ''
    }
  },
  matchingConfigurationParameters: { isLoading: false, error: null, data: [] },
  matchingConfigById: {},
  matchingConfigurationRiskIndicators: {
    isLoading: false,
    error: null,
    data: []
  },
  matchingConfigurationRiskParameters: {
    isLoading: false,
    error: null,
    data: []
  }
};

function nsMatchingConfig(state = initialState, action) {
  switch (action.type) {
    case NS_SAVE_MATCHING_CONFIG_DATA:
    case NS_POST_CREATE_MATCHING_CONFIG:
    case NS_PUT_UPDATE_MATCHING_CONFIG:
      return {
        ...state,
        createUpdate: {
          ...state.createUpdate,
          isLoading: true
        }
      };
    case NS_SAVE_MATCHING_CONFIG_DATA_TO_REDUX:
      return {
        ...state,
        createUpdate: {
          ...state.createUpdate,
          isLoading: false,
          ...action.payload
        }
      };
    case NS_GET_MATCHING_CONFIG_PARAMATERS_DATA:
      return {
        ...state,
        matchingConfigurationParameters: {
          isLoading: true,
          data: [],
          error: null
        }
      };
    case NS_GET_MATCHING_CONFIG_PARAMATERS_SUCCESS:
      return {
        ...state,
        matchingConfigurationParameters: {
          isLoading: false,
          data: action.payload,
          error: null
        }
      };
    case NS_GET_MATCHING_CONFIG_PARAMATERS_FAIL:
      return {
        ...state,
        matchingConfigurationParameters: {
          isLoading: false,
          data: [],
          ...action.payload
        }
      };
    case NS_GET_MATCHING_CONFIG_LIST:
      return {
        ...initialState,
        matchingConfigList: { isLoading: true, error: null, data: null }
      };
    case NS_GET_MATCHING_CONFIG_LIST_SUCCESS:
      return {
        ...initialState,
        matchingConfigList: {
          isLoading: false,
          data: action.payload,
          error: null
        }
      };
    case NS_GET_MATCHING_CONFIG_LIST_FAIL:
      return {
        ...initialState,
        matchingConfigList: { isLoading: false, data: null, ...action.payload }
      };
    case NS_POST_CREATE_MATCHING_CONFIG_SUCCESS:
    case NS_PUT_UPDATE_MATCHING_CONFIG_SUCCESS:
      return {
        ...state,
        createUpdate: {
          isLoading: false,
          response: action.payload,
          error: ''
        }
      };
    case NS_POST_CREATE_MATCHING_CONFIG_FAIL:
    case NS_PUT_UPDATE_MATCHING_CONFIG_FAIL:
      return {
        ...state,
        createUpdate: {
          ...state.createUpdate,
          isLoading: false,
          response: null,
          error: action.payload
        }
      };
    case NS_GET_MATCHING_CONFIG:
      return {
        ...initialState,
        matchingConfigById: {
          isLoading: true
        }
      };
    case NS_GET_MATCHING_CONFIG_SUCCESS:
      return {
        ...initialState,
        matchingConfigById: {
          isLoading: false,
          data: action.payload
        }
      };
    case NS_GET_MATCHING_CONFIG_FAIL:
      return {
        ...initialState,
        matchingConfigById: {
          isLoading: false,
          error: action.payload
        }
      };
    case NS_GET_MATCHING_CONFIG_BY_ID:
      return {
        ...initialState,
        matchingConfigurationParameters: {
          isLoading: false,
          error: null,
          data: []
        },
        matchingConfigById: {
          isLoading: true
        }
      };
    case NS_GET_MATCHING_CONFIG_BY_ID_SUCCESS:
      return {
        ...initialState,
        matchingConfigurationParameters: {
          isLoading: false,
          data: action?.payload?.matchingParameters,
          error: null
        },
        matchingConfigById: {
          isLoading: false,
          data: action.payload,
          error: ''
        }
      };
    case NS_GET_MATCHING_CONFIG_BY_ID_FAIL:
      return {
        ...initialState,
        matchingConfigurationParameters: {
          isLoading: false,
          error: null,
          data: []
        },
        matchingConfigById: {
          isLoading: false,
          data: null,
          error: action.payload
        }
      };
    case NS_GET_MATCHING_CONFIG_RISK_INDICATORS_DATA:
      return {
        ...state,
        matchingConfigurationRiskParameters: {
          isLoading: true,
          data: [],
          error: null
        }
      };
    case NS_GET_MATCHING_CONFIG_RISK_INDICATORS_SUCCESS:
      return {
        ...initialState,
        matchingConfigurationRiskParameters: {
          isLoading: false,
          data: action.payload,
          error: null
        }
      };
    case NS_GET_MATCHING_CONFIG_RISK_INDICATORS_FAIL:
      return {
        ...state,
        matchingConfigurationRiskParameters: {
          isLoading: false,
          data: [],
          ...action.payload
        }
      };

    default:
      return {
        ...state
      };
  }
}

export default nsMatchingConfig;
